var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.439C2 12.8208 2.146 13.1465 2.44922 13.4385L11.209 22.0073C11.4448 22.2544 11.7593 22.3779 12.1187 22.3779C12.8486 22.3779 13.4214 21.8164 13.4214 21.0752C13.4214 20.7158 13.2754 20.3901 13.0283 20.1431L5.1333 12.439L13.0283 4.73486C13.2754 4.47656 13.4214 4.15088 13.4214 3.7915C13.4214 3.06152 12.8486 2.5 12.1187 2.5C11.7593 2.5 11.4448 2.62354 11.209 2.87061L2.44922 11.4395C2.146 11.7314 2.01123 12.0571 2 12.439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.e88e6e5bf5aa22768ef3d7e5325382b1.svg";
export { ForwardRef as ReactComponent };